package one.healthium.onboarding.domain.configs


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.ReviewItem
import one.healthium.onboarding.domain.models.Slider

@Serializable
@SerialName("calculating_plan")
data class CalculatingPersonalPlanScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("header") val header: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("sliders") val sliders: List<Slider> = emptyList(),
    @SerialName("reviews") val reviews: List<ReviewItem> = emptyList(),
) : ScreenConfig